import { render } from "./DetailTooltip.vue?vue&type=template&id=271635d1"
import script from "./DetailTooltip.vue?vue&type=script&lang=js"
export * from "./DetailTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__